import type { Set as FestivalSet } from '../types'

/** When the set last moved (epoch millis); 0 if never or unreadable. */
export function scheduleChangedMillis(set: FestivalSet): number {
  const t = set.scheduleChangedAt?.toMillis?.()
  return typeof t === 'number' && Number.isFinite(t) ? t : 0
}

/** `scheduleSeen.events` key for one day of an event's schedule (the bare event id holds the first open). */
export function scheduleSeenDayKey(eventId: string, day: string): string {
  return `${eventId}_${day}`
}

/** Sets that moved after `baseline`; none without one (a first visit). */
export function updatedSetIds(sets: readonly FestivalSet[], baseline: number | null): ReadonlySet<string> {
  if (baseline === null) return new Set()
  return new Set(sets.filter(s => scheduleChangedMillis(s) > baseline).map(s => s.id))
}
